export const baseURL = process.env.REACT_APP_SSP_BACKEND_URL.endsWith('/')
  ? process.env.REACT_APP_SSP_BACKEND_URL.slice(0, -1)
  : process.env.REACT_APP_SSP_BACKEND_URL;

// Fetch data for the Tests tab
export const fetchTestsData = async (setTestsData, handleUnauthorized, setPowerUser) => {
  try {
    const authToken = localStorage.getItem('apiToken');
    const isPowerUser = localStorage.getItem('isAppPowerUser');
    const response = await fetch(baseURL + '/api/tests', {
      headers: {
        api_token: authToken,
        user_type: 'OktaUser',
      },
    });
    if (response.status === 401) {
      handleUnauthorized();
    } else {
      const data = await response.json();
      setTestsData(data);
      setPowerUser(isPowerUser === "true" || isPowerUser === true);
    }
  } catch (error) {
    console.error('Error fetching tests data:', error);
  }
};

export const fetchTestsDataByAppType = async (appType, setTestsData, handleUnauthorized) => {
  try {
    const authToken = localStorage.getItem('apiToken');
    const response = await fetch(`${baseURL}/api/tests/by-appType/${appType}`, {
      headers: {
        api_token: authToken,
        user_type: 'OktaUser',
      },
    });
    if (response.status === 401) {
      handleUnauthorized();
    } else {
      const data = await response.json();
      setTestsData(data);
    }
  } catch (error) {
    console.error('Error fetching tests data by appType:', error);
  }
};

export const fetchTestTermination = async (row) => {
  try {
    const authToken = localStorage.getItem('apiToken');
    const response = await fetch(baseURL + '/api/tests/terminate/' + row._id, {
      method: 'PUT',
      headers: {
        api_token: authToken,
        user_type: 'OktaUser'
      }
    });

    const data = await response.json();

    if (response.status === 401) {
      handleUnauthorized();
    } else {
      return data;
    }
  } catch (error) {
    console.error('Error fetching tests data:', error);
  }
}

// Fetch data for the Agents tab
export const fetchAgentsData = async (setAgentsData) => {
  try {
    const authToken = localStorage.getItem('apiToken');

    const response = await fetch(baseURL + '/api/agents/agents-with-devices', {
      headers: {
        api_token: authToken,
        user_type: 'OktaUser',
      }
    });

    if (response.status === 401) {
      handleUnauthorized();
    } else {
      const data = await response.json();
      setAgentsData(data.agentDeviceTree);
    }
  } catch (error) {
    console.error('Error fetching agents data:', error);
  }
};

// Fetch data for the Search tab
export const fetchSearchData = async (params, setSearchData) => {
  try {
    const authToken = localStorage.getItem('apiToken');
    const { client, version, suite, branch, dates, passRange, dataIdForward } = params;

    var defaultHeaders = {
      'api_token': authToken,
      'user_type': "OktaUser",
      'testId': dataIdForward ? dataIdForward : null,
      'version': version,
      'client': client,
      'start_date': dates != null && dates.length > 0 ? formatDate(dates[0]) : null,
      'end_date': dates != null && dates.length > 1 ? formatDate(dates[1]) : null,
      'pass_rate': passRange,
      'branch': branch,
      'suite': suite
    }

    const response = await fetch(baseURL + '/api/results/', {
      headers: defaultHeaders,
    });

    if (response.status === 401) {
      handleUnauthorized();
    } else {
      const data = await response.json();
      setSearchData(data);
    }
  } catch (error) {
    console.error('Error fetching search data:', error);
  }
};

// Fetch data for the Config tab
export const fetchConfigData = async (setTestConfig, setSchedulerConfig) => {
  try {
    const authToken = localStorage.getItem('apiToken');

    const responseScheduler = await fetch(baseURL + '/api/config/scheduler-config', {
      headers: {
        api_token: authToken,
        user_type: 'OktaUser',
      }
    });

    if (responseScheduler.status === 401) {
      handleUnauthorized();
      return;
    } else {
      const dataScheduler = await responseScheduler.json();
      setSchedulerConfig(dataScheduler);
    }

    const responseTests = await fetch(baseURL + '/api/config/test-config', {
      headers: {
        api_token: authToken,
        user_type: 'OktaUser',
      }
    });

    if (responseTests.status === 401) {
      handleUnauthorized();
    } else {
      const dataTests = await responseTests.json();
      setTestConfig(dataTests);
    }
  } catch (error) {
    console.error('Error fetching config data:', error);
  }
};

// Fetch data for the Artifacts tab
export const fetchArtifactsData = async (setArtifactsData) => {
  try {
    const authToken = localStorage.getItem('apiToken');
    const response = await fetch(baseURL + '/api/artifacts/', {
      headers: {
        api_token: authToken,
        user_type: 'OktaUser',
      },
    });
    if (response.status === 401) {
      handleUnauthorized();
    } else {
      const data = await response.json();
      setArtifactsData(data);
    }
  } catch (error) {
    console.error('Error fetching artifacts data:', error);
  }
};

// Fetch data for the Run tab
export const fetchBuildData = async (selectedClient, branchPattern, versionSearch, setSelectedBuilds, setInfrastructure, setPowerUser) => {
  try {
    const authToken = localStorage.getItem('apiToken');
    const isPowerUser = localStorage.getItem('isAppPowerUser');

    const responseBuilds = await fetch(baseURL + '/api/builds/', {
      headers: {
        api_token: authToken,
        user_type: 'OktaUser',
        version: versionSearch,
        client: selectedClient,
        branch: branchPattern,
      }
    });

    if (responseBuilds.status === 401) {
      handleUnauthorized();
    } else {
      const data = await responseBuilds.json();
      setSelectedBuilds(data);
    }

    const responseInfrastructure = await fetch(baseURL + '/api/agents/agents-with-devices-table', {
      headers: {
        api_token: authToken,
        user_type: 'OktaUser'
      }
    });

    if (responseInfrastructure.status === 401) {
      handleUnauthorized();
    } else {
      const data = await responseInfrastructure.json();
      setInfrastructure(data);
    }

    setPowerUser(isPowerUser === "true" || isPowerUser === true);

  } catch (error) {
    console.error('Error fetching build data:', error);
  }
};

export const getDevicesPerPlatform = async (build, setInfrastructure) => {
  const authToken = localStorage.getItem('apiToken');

  const responseInfrastructure = await fetch(baseURL + '/api/agents/agents-with-devices-table', {
    headers: {
      api_token: authToken,
      user_type: 'OktaUser',
      platform: build.platform
    }
  });

  if (responseInfrastructure.status === 401) {
    handleUnauthorized();
  } else {
    const data = await responseInfrastructure.json();
    setInfrastructure(data);
  }
}

export const triggerTestExecution = async (selectedSuite, selectedBuild, devices, setExecutionStatus) => {
  try {
    const authToken = localStorage.getItem('apiToken');

    const responseBuilds = await fetch(baseURL + '/api/tests/run-with-params', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json', // Specify that the request body is JSON
        api_token: authToken, // Keep the token in headers
        user_type: 'OktaUser' // You can keep this in headers if needed for authentication
      },
      body: JSON.stringify({
        suite: selectedSuite,
        build: selectedBuild,
        devices: devices,
      })
    });

    if (responseBuilds.status === 401) {
      handleUnauthorized();
    } else {
      const data = await responseBuilds.json();
      setExecutionStatus(data);
    }
  } catch (error) {
    console.error('Error fetching build data:', error);
  }
};
// Handle unauthorized access
export const handleUnauthorized = () => {
  localStorage.removeItem('apiToken');
  localStorage.removeItem('apiTokenTimestamp');

  window.location.href = '/login'; // Redirect to the login page or another appropriate route
};

// Format date to DD/MM/YY
export const formatDate = (date) => {
  const d = new Date(date);
  let month = '' + (d.getMonth() + 1);
  let day = '' + d.getDate();
  let year = '' + d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;
  year = year.slice(-2); // Get last two digits of the year

  return [day, month, year].join('/');
};


export const fetchPowerUsersData = async (setPowerUsersData) => {
  try {
    const authToken = localStorage.getItem('apiToken');
    const response = await fetch(baseURL + '/api/powerUsers', {
      headers: {
        api_token: authToken,
        user_type: 'OktaUser',
      },
    });
    if (response.status === 401) {
      handleUnauthorized();
    } else {
      const data = await response.json();
      setPowerUsersData(data);
    }
  } catch (error) {
    console.error('Error fetching tests data:', error);
  }
};

// need to put in db at some point
export const clients = [
  { label: 'Cashman', value: 'CC' },
  { label: 'Lightning Link', value: 'LL' },
  { label: 'Heart of Vegas', value: 'HOV_CRA' },
  { label: 'Mighty Fu Casino', value: 'MFC' }
];

export const suites = [
  { name: 'Smoke', code: 'smoke' },
  { name: 'Regression', code: 'regression' },
  { name: 'SingleGame', code: 'single-game' },
  { name: 'Sanity', code: 'sanity' },
  { name: 'VerifyValid', code: 'verify-valid' }
];

export const platforms = [
  { label: 'All', value: 'all' },
  { label: 'iOS', value: 'iOS' },
  { label: 'Android', value: 'Android' }
];


export const getToken = () => {
  return localStorage.getItem('apiToken');
}

export function dateTemplate(rowData, column) {
  // Use optional chaining and nullish coalescing to safely access properties
  var date = rowData?.['createdAt'] ||
    rowData?.['creationDate'] ||
    rowData?.['lastExecutionDate'] ||
    rowData?.data?.['lastUsed'] ||
    rowData?.data?.['lastSeen'];

  if (date != null && date.includes("T")) { // Check for ISO format using includes instead of indexOf
    return formatDateISO(date);
  }

  return date; // Return the date value for old db formats, should consider further enhancements for sorting.
}


const formatDateISO = (isoString) => {
  const date = new Date(isoString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

// Jenkins Plans Data Flow Functions
export const fetchJenkinsPlans = async (setPlans, handleUnauthorized) => {
    try {
        const authToken = localStorage.getItem('apiToken');
        const response = await fetch(`${baseURL}/api/jenkins-plans`, {
            headers: {
                api_token: authToken,
                user_type: 'OktaUser',
            }
        });
        
        if (response.status === 401) {
            handleUnauthorized();
            return;
        }
        
        if (!response.ok) {
            console.error('Server responded with status:', response.status);
            return;
        }

        const data = await response.json();
        setPlans(data);
    } catch (error) {
        console.error('Error fetching Jenkins plans:', error);
    }
};

export const deleteJenkinsPlan = async (planId, handleUnauthorized) => {
    try {
        const authToken = localStorage.getItem('apiToken');
        const response = await fetch(`${baseURL}/api/jenkins-plans/${planId}`, {
            method: 'DELETE',
            headers: {
                api_token: authToken,
                user_type: 'OktaUser',
            }
        });
        
        if (response.status === 401) {
            handleUnauthorized();
        }
        return response.ok;
    } catch (error) {
        console.error('Error deleting Jenkins plan:', error);
        return false;
    }
};

export const updateJenkinsPlan = async (planId, handleUnauthorized) => {
    try {
        const authToken = localStorage.getItem('apiToken');
        const response = await fetch(`${baseURL}/api/jenkins-plans/${planId}/update`, {
            method: 'POST',
            headers: {
                api_token: authToken,
                user_type: 'OktaUser',
            }
        });
        
        if (response.status === 401) {
            handleUnauthorized();
        }
        return response.ok;
    } catch (error) {
        console.error('Error updating Jenkins plan:', error);
        return false;
    }
};

export const saveJenkinsPlan = async (plan, handleUnauthorized) => {
    try {
        const authToken = localStorage.getItem('apiToken');
        const endpoint = plan._id 
            ? `/api/jenkins-plans/${plan._id}` 
            : '/api/jenkins-plans';

        const response = await fetch(baseURL + endpoint, {
            method: plan._id ? 'PUT' : 'POST',
            headers: {
                'Content-Type': 'application/json',
                'api_token': authToken,
                'user_type': 'OktaUser'
            },
            body: JSON.stringify(plan)
        });

        if (response.status === 401) {
            handleUnauthorized();
            return { success: false };
        }

        return { 
            success: response.ok,
            data: response.ok ? await response.json() : null
        };
    } catch (error) {
        console.error('Error saving Jenkins plan:', error);
        return { success: false };
    }
};